var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStoryFeatured(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1600,
    height: 1600,
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M747.6 680.4l43.199 212.4-190.8-106.8-190.8 106.8 43.199-212.4-160.8-146.4 217.2-25.199 91.199-195.6 91.199 196.8 217.2 25.199z",
    fill: "#474747"
  })));
}
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTIwMHB0IiBoZWlnaHQ9IjEyMDBwdCIgdmVyc2lvbj0iMS4xIiB2aWV3Qm94PSIwIDAgMTIwMCAxMjAwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogPHBhdGggZD0ibTc0Ny42IDY4MC40IDQzLjE5OSAyMTIuNC0xOTAuOC0xMDYuOC0xOTAuOCAxMDYuOCA0My4xOTktMjEyLjQtMTYwLjgtMTQ2LjQgMjE3LjItMjUuMTk5IDkxLjE5OS0xOTUuNiA5MS4xOTkgMTk2LjggMjE3LjIgMjUuMTk5eiIgZmlsbD0iIzQ3NDc0NyIvPgo8L3N2Zz4K";
export { SvgStoryFeatured as ReactComponent };